export const selectRejectionReportsFilters = (state) =>
  state?.rejectionsReports?.filters;
export const selectRejectionReportsFilterWithValues = (state) =>
  state?.rejectionsReports?.filterWithvalues;
export const selectRejectionsReportsTimeFrame = (state) =>
  state?.rejectionsReports?.time;
export const selectRejectionsReportsGroup = (state) =>
  state?.rejectionsReports?.group;

export const selectRejectionReportsCard = (state) =>
  state?.rejectionsReports?.cards;
export const selectRejectionReportsCardLoading = (state) =>
  state?.rejectionsReports?.isCardLoading;

export const selectRejectionBySource = (state) =>
  state?.rejectionsReports?.rejectionSources;
export const selectRejectionBySourceLoading = (state) =>
  state?.rejectionsReports?.isRejectionSourcesLoading;

export const selectRejectionByStage = (state) =>
  state?.rejectionsReports?.rejectionStage;
export const selectRejectionByStageLoading = (state) =>
  state?.rejectionsReports?.isRejectionStageLoading;

export const selectRejectedReasons = (state) =>
  state?.rejectionsReports?.rejectedReasons;
export const selectRejectedReasonsLoading = (state) =>
  state?.rejectionsReports?.isRejectedReasonsLoading;

export const selectChart = (state) => state?.rejectionsReports?.chart;
export const selectTable = (state) => state?.rejectionsReports?.table;
export const selectChartLoading = (state) =>
  state?.rejectionsReports?.isChartLoading;
export const selectTableLoading = (state) =>
  state?.rejectionsReports?.isTableLoading;
